export class PrescriptionNonDispensationRequest {
    public idMedicalPrescription: number;
    public idPrescriptionMedicine: number;
    public idPrescriptionSolutionMedicine: number;
    public idPrescriptionStatus: number;
    public nonDispensationReason: string;
}